import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import { getIsPaidOrProcessing, getIsPublished, getIsPublishing } from 'quotes-ui-lib/utils/status';
import { isTrue } from 'quotes-ui-lib/utils/isTrue';
import { isCPQQuote as getIsCPQQuote } from '../utils/templates';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteButton = ({
  quote,
  onClick
}) => {
  const isCPQQuote = getIsCPQQuote(quote);
  const isTestMode = isTrue(getQuoteProperty(quote, 'hs_test_mode'));
  const canDeleteQuote = isTestMode || isCPQQuote && !getIsPublishing(quote) && !getIsPublished(quote) && !getIsPaidOrProcessing(quote) || !isCPQQuote && !getIsPaidOrProcessing(quote);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isCPQQuote ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.delete.disabledTooltipCPQ"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.delete.disabledTooltip"
    }),
    disabled: canDeleteQuote,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "delete-quote-btn",
      "data-selenium-test": "delete-quote-btn",
      onClick: onClick,
      disabled: !canDeleteQuote,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.delete.buttonText"
      })
    }, "deleteButton")
  }, "deleteButtonTooltip");
};
export default DeleteButton;
export const showDeleteButton = canCurrentUserEditQuote => {
  return canCurrentUserEditQuote;
};